import * as Yup from "yup";

export const dataModel = {
  varietyCode: "",
  origin: "",
  destination: "",
  batch: "",
  borrellID: "",
  harvestYear: 0,
};

export const validationDataModel = () => {
  return Yup.object().shape({
    varietyCode: Yup.string().required("forms.validations.required"),
    origin: Yup.string().required("forms.validations.required"),
    destination: Yup.string().required("forms.validations.required"),
    batch: Yup.string().required("forms.validations.required"),
    borrellID: Yup.number().required("forms.validations.required"),
    harvestYear: Yup.string().required("forms.validations.required"),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
